
import React, { useState } from 'react';
import { X, Copy, Share2, MessageCircle, Check } from 'lucide-react';
import TerviLogo from '../common/TerviLogo';

const ShareProfileModal = ({ isOpen, onClose, serviData, serviId, showMessage }) => {
    const [copied, setCopied] = useState(false);

    if (!isOpen || !serviData) return null;

    const displayName = serviData.companyName || serviData.name || 'Profissional';
    const category = serviData.mainCategory;
    const shareUrl = `${window.location.origin}/v/${serviId}`;
    // Usando QuickChart para um QR Code mais rápido e robusto
    const qrUrl = `https://quickchart.io/qr?text=${encodeURIComponent(shareUrl)}&size=300&margin=2`;

    const shareText = `Confira meu perfil na T-SERVI! 🛠️\n\nOlá! Sou ${displayName}${category ? `, especialista em ${category}` : ''}.\nVeja meu portfólio e solicite um orçamento direto pelo link:\n${shareUrl}\n\nT-SERVI - Profissionais de Confiança.`;

    const handleCopy = () => {
        navigator.clipboard.writeText(shareText);
        setCopied(true);
        showMessage("Link e mensagem copiados!", "success");
        setTimeout(() => setCopied(false), 2000);
    };

    const handleWhatsApp = () => {
        const url = `https://wa.me/?text=${encodeURIComponent(shareText)}`;
        window.open(url, '_blank');
    };

    const handleNativeShare = async () => {
        try {
            if (navigator.share) {
                await navigator.share({
                    title: `T-SERVI: ${displayName}`,
                    text: shareText,
                    url: shareUrl
                });
            } else {
                handleCopy();
            }
        } catch (e) {}
    };

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[150] flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-white rounded-[2.5rem] w-full max-w-sm overflow-hidden relative shadow-2xl flex flex-col animate-slide-up">
                <button onClick={onClose} className="absolute top-6 right-6 p-2 bg-gray-100 rounded-full text-gray-500 z-10 active:scale-90 transition-all"><X size={20}/></button>

                <div className="p-8 pb-4 text-center">
                    <TerviLogo size={24} className="mx-auto mb-6 opacity-40" />

                    {/* Cartão de Visita Digital */}
                    <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-[2rem] p-6 text-white shadow-xl mb-6 relative overflow-hidden text-left">
                        <div className="absolute -top-10 -right-10 w-32 h-32 bg-white/10 rounded-full blur-2xl"></div>
                        <div className="relative z-10">
                            <h3 className="text-lg font-black uppercase tracking-tighter leading-tight mb-1 truncate">{displayName}</h3>
                            <p className="text-[10px] font-bold text-blue-200 uppercase tracking-widest mb-4 truncate">{category}</p>

                            <div className="bg-white p-2 rounded-2xl w-32 h-32 mx-auto shadow-inner">
                                <img src={qrUrl} alt="QR Code" className="w-full h-full object-contain rounded-lg" />
                            </div>

                            <p className="text-[8px] text-center mt-3 font-bold opacity-70 uppercase tracking-widest">Aponte a câmera para ver meu perfil</p>
                        </div>
                    </div>

                    <div className="space-y-3">
                        <button
                            onClick={handleWhatsApp}
                            className="w-full py-4 bg-[#25D366] text-white rounded-2xl font-black text-[10px] uppercase tracking-widest flex items-center justify-center space-x-2 shadow-lg active:scale-95 transition-all"
                        >
                            <MessageCircle size={18} />
                            <span>Enviar pelo WhatsApp</span>
                        </button>

                        <div className="grid grid-cols-2 gap-3">
                            <button
                                onClick={handleCopy}
                                className="py-4 bg-gray-100 text-gray-700 rounded-2xl font-black text-[10px] uppercase tracking-widest flex items-center justify-center space-x-2 active:scale-95 transition-all"
                            >
                                {copied ? <Check size={16} className="text-green-600"/> : <Copy size={16}/>}
                                <span>{copied ? 'Copiado' : 'Copiar'}</span>
                            </button>
                            <button
                                onClick={handleNativeShare}
                                className="py-4 bg-gray-100 text-gray-700 rounded-2xl font-black text-[10px] uppercase tracking-widest flex items-center justify-center space-x-2 active:scale-95 transition-all"
                            >
                                <Share2 size={16}/>
                                <span>Outros</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="p-6 pt-2 text-center border-t border-gray-50 mt-4 bg-gray-50/50">
                    <p className="text-[9px] font-black text-gray-400 uppercase tracking-widest">Use este link para divulgar seu trabalho</p>
                </div>
            </div>
        </div>
    );
};

export default ShareProfileModal;
